/**
 * TaskPortalProjectService
 * Service for project-related task portal operations.
 * Provides project summaries and tasks by project.
 * Route: api/task-portal/projects
 */
import { TaskPortalBaseService } from './TaskPortalBaseService';
export class TaskPortalProjectService extends TaskPortalBaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? TaskPortalProjectService.DEFAULT_SERVICE_PATH,
            basePath: config?.basePath ?? 'api/task-portal/projects',
            endpoints: config?.endpoints,
        });
    }
    /**
     * Get project summaries with task counts.
     */
    async getProjectSummaries() {
        const response = await this.get();
        return response.data ?? [];
    }
    /**
     * Get project summaries (raw response).
     */
    async getProjectSummariesRaw() {
        return this.get();
    }
    /**
     * Get tasks for a specific project.
     */
    async getProjectTasks(projectId, filter) {
        const endpoint = `${projectId}/tasks`;
        if (filter) {
            const response = await this.post(endpoint, filter);
            return response.data ?? [];
        }
        const response = await this.get(endpoint);
        return response.data ?? [];
    }
    /**
     * Get tasks for a specific project (raw response).
     */
    async getProjectTasksRaw(projectId, filter) {
        const endpoint = `${projectId}/tasks`;
        if (filter) {
            return this.post(endpoint, filter);
        }
        return this.get(endpoint);
    }
}
TaskPortalProjectService.DEFAULT_SERVICE_PATH = 'tasks';
//# sourceMappingURL=TaskPortalProjectService.js.map